module.exports = __webpack_public_path__ + "static/media/mask.88d0ca1d.png";